<script setup lang="ts">
import { getCategoryRoute, getTranslatedProperty } from '@shopware-pwa/helpers-next';

defineOptions({ name: 'CategoryNode' });

const props = defineProps({
  node: { type: Object as PropType<any>, required: true },
  depth: { type: Number as PropType<number>, default: 0 },
});

const { isActive } = useActivePath();

const active = computed(() => isActive(props.node?.seoUrls));
const children = computed(() => (props.node?.children && props.node.children.length ? props.node.children : null));

const liClass = computed(() => (props.depth === 0 ? 'mt-3 pl-2' : 'ml-2 mt-2 text-base'));
const ulClass = computed(() => (props.depth === 0 ? 'ml-1 border-l border-gray-light pl-1' : 'ml-1 pl-1'));
const linkBaseClass = computed(() =>
  props.depth === 0
    ? 'non-italic text-brand-neutral-black font-main text-sm leading-5'
    : 'non-italic font-main text-sm font-normal leading-5'
);
const linkConditionalClass = computed(() =>
  props.depth === 0 ? { 'font-bold': active.value, 'font-normal': !active.value } : { 'text-brand-neutral-black': active.value, 'text-gray': !active.value }
);
</script>

<template>
  <li :key="props.node.id" :class="liClass">
    <LocaleLink :to="getCategoryRoute(props.node)" :class="[linkBaseClass, linkConditionalClass]">
      {{ getTranslatedProperty(props.node, 'name') }}
    </LocaleLink>

    <ul v-if="children && active" :class="ulClass">
      <CategoryNode v-for="child in children" :key="child.id" :node="child" :depth="props.depth + 1" />
    </ul>
  </li>
</template>
